import * as yup from 'yup';

import { BaseYup, MAX_INPUT } from '@/config/baseYup';

export const paymentSearchFormSchema = BaseYup.object({
  keyword: BaseYup.string().max(MAX_INPUT),
  transaction_status: BaseYup.string().max(MAX_INPUT).nullable(),
  start_date: BaseYup.date().nullable(),
  end_date: BaseYup.date().nullable(),
});

export type PaymentFormSearchType = yup.InferType<typeof paymentSearchFormSchema>;